<template>
  <div class="fixed right-0 inset-y-0 w-full max-w-sm bg-white z-80">
    <div class="flex flex-col h-full">
      <div class="px-6 py-5 lg:py-6 border-b bg-white">
        <div class="grid grid-cols-6">
          <div
            class="col-span-4 col-start-2 lg:col-start-1 lg:col-span-5 text-md lg:text-lg flex justify-center lg:justify-start items-center space-x-3"
          >
            <div class="h-5 w-5 block">
              <IconFavourites />
            </div>
            <div class="leading-none">Favourites ({{ items.length }})</div>
          </div>
          <div class="col-span-1 justify-end flex items-center">
            <button class="link" @click="$store.commit('closeSiteFavourites')">
              <div class="w-5 h-5">
                <IconCross />
              </div>
              <span class="sr-only">Close favourites list</span>
            </button>
          </div>
        </div>
      </div>
      <div class="h-full overflow-y-auto scrolling-touch">
        <div
          v-for="(item, index) in items"
          :key="index"
          :style="{ backgroundColor: item.hex }"
          :class="`text-${item.textColour.value || item.textColour}`"
          class="px-6 pt-6 pb-4 flex flex-col items-between"
        >
          <div class="mb-24">
            <div class="font-bold text-md mb-2">{{ item.title }}</div>
            <ProductColourTestPot
              v-if="testPotProductId && getTestPot(item)"
              link
              :test-pot="getTestPot(item)"
              source="favourites_list"
              :paint-colour="item.hex || ''"
              :colour-title="item.title || ''"
              >{{ item.title }} Test Pot - ${{
                getTestPot(item).salePrice
              }}</ProductColourTestPot
            >
          </div>
          <button
            type="button"
            class="link underline text-left"
            @click="removeFavourite(item)"
          >
            Remove
          </button>
        </div>
        <div
          v-if="items.length == 0"
          class="p-6 text-center"
          data-testid="empty-favourites-message"
        >
          You haven't added any colours to your favourites. Visit the
          <a class="link underline" href="/colours">colours</a> page to start
          adding your favourite colours.
        </div>
        <div v-if="items.length" class="p-6 bg-white text-center lg:text-left">
          <button class="btn-soft" @click="isSendFormOpen = true">
            Email me my favourites
          </button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <Modal v-show="isSendFormOpen" @close="isSendFormOpen = false">
        <SiteFavouritesEmailForm
          :favourites="items"
          @close="handleEmailFormSubmit()"
        />
      </Modal>
    </transition>
  </div>
</template>

<script>
import api from "../../js/apiClient";
import { mapActions, mapState } from "vuex";
import IconFavourites from "../../../templates/_includes/svg/icon-favourites.svg";
import IconCross from "../../../templates/_includes/svg/icon-cross.svg";
import Modal from "../Modal/Modal.vue";
import SiteFavouritesEmailForm from "./SiteFavouritesEmailForm.vue";
import ProductColourTestPot from "../Product/TestPotAddToCart.vue";

export default {
  name: "SiteFavourites",

  components: {
    IconFavourites,
    IconCross,
    Modal,
    SiteFavouritesEmailForm,
    ProductColourTestPot,
  },

  data() {
    return {
      isSendFormOpen: false,
      favouriteTestPots: []
    };
  },

  props: {
    testPotProductId: {
      type: Number,
      default: null,
    },
  },

  computed: mapState("favourites", ["error", "isLoading", "items"]),

  methods: {
    ...mapActions("favourites", ["removeFavourite"]),

    handleEmailFormSubmit() {
      this.isSendFormOpen = false;
      this.$store.commit("closeSiteFavourites");
    },
    
    async getFavouriteTestPots() {

      try {
        const paintTestPots = await api.variants.queryPaintTestPots(
          this.testPotProductId,
          this.items.map(item => item.id),
        );

        this.favouriteTestPots = this.getColourIds(paintTestPots?.variants);

      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
        this.favouriteTestPots = [];
 
      }
    },

    getColourIds(paintVariants) {
      let paintVariantsFmt = paintVariants
        ?.filter((variant) => variant.paintColour.length !== 0)
        ?.map((variant) => {
            return { ...variant, colourId: variant.paintColour[0].id };
        });
      return paintVariantsFmt;
    },

    getTestPot(item) {
      return this.favouriteTestPots.filter(testPot => parseInt(testPot.colourId) == parseInt(item.id))[0];
    }
  },

  mounted() {
    this.getFavouriteTestPots();  
  },

  watch: {
    items() {
      this.getFavouriteTestPots(); 
    }
  }
};
</script>
